module.exports = __webpack_public_path__ + "static/media/edf_logo.b6e3787b.bmp";


//////////////////
// WEBPACK FOOTER
// ./src/components/shared-components/edf_logo.bmp
// module id = 174
// module chunks = 0